var path = 'scripts/views/components/cycle-matched-receipts-button.html';
var html = "<button id=\"cycle-matched-receipts-button\" class=\"btn btn-default mlm\"\n        ng-click=\"$ctrl.openModal()\"\n        analytics-on=\"click\"\n        analytics-properties=\"{eventAsset:'Receipts'}\">\n    <span class=\"fa fa-file-text\">&nbsp;</span>\n    <span translate>receipt.Receipts</span>\n</button>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/main/resources/static/scripts/views/components/cycle-matched-receipts-button.html
// module id = 308
// module chunks = 0